// extracted by mini-css-extract-plugin
export default {"Filter_Blocks":"FilterBody_Filter_Blocks__ChOUI","Selected":"FilterBody_Selected__RlXOj","Not_Selected":"FilterBody_Not_Selected__j3rGp"};